import { Pipe, PipeTransform } from '@angular/core';
import { User } from '../../core/User';

@Pipe({
  name: 'localCurrency'
})
export class LocalCurrencyPipe implements PipeTransform {

  transform(value: number | string, locale?: string): string {
    if (value === null || typeof value === 'undefined' || isNaN(Number(value))) {
      return 'N/A';
    }
    if (typeof locale === 'undefined')
      locale = User.sessionCulture;
    if (locale === null)
      locale = 'en-ca';
    if (locale === 'fr-ca')
      return new Intl.NumberFormat(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2, }).format(Number(value)) + ' $';
    else
      return '$' + new Intl.NumberFormat(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2, }).format(Number(value));
  }
}
